export enum RaceEnum {
  White = 1,
  BlackOrAfricanAmerican = 2,
  AmericanIndianOrAlaskaNative = 3,
  AsianIndian = 4,
  Chinese = 5,
  Filipino = 6,
  Japanese = 7,
  Korean = 8,
  Vietnamese = 9,
  OtherAsian = 10,
  NativeHawaiian = 11,
  GuamanianChamorro = 12,
  Samoan = 13,
  PacificIslander = 14,
  UnableToRespond = 15,
  DeclinesToRespond = 16,
  NoneOfTheAbove = 17
}

export const RaceOptions = [
{ id: 1, label: 'A. White' },
{ id: 2, label: 'B. Black or African-American' },
{ id: 3, label: 'C. American Indian or Alaska Native' },
{ id: 4, label: 'D. Asian Indian' },
{ id: 5, label: 'E. Chinese' },
{ id: 6, label: 'F. Filipino' },
{ id: 7, label: 'G. Japanese' },
{ id: 8, label: 'H. Korean' },
{ id: 9, label: 'I. Vietnamese' },
{ id: 10, label: 'J. Other Asian' },
{ id: 11, label: 'K. Native Hawaiian' },
{ id: 12, label: 'L. Guamanian or Chamorro' },
{ id: 13, label: 'M. Samoan' },
{ id: 14, label: 'N. Other Pacific Islander' },
{ id: 15, label: 'X. Patient unable to responsd' },
{ id: 16, label: 'Y. Patient declines to respond' },
{ id: 17, label: 'Z. None of the above' }
];
